import { getEnv } from '@ctct/ctct-helpers';

import axios from '../axiosConfig';

const getBaseUrl = () => {
  if (getEnv() === 'local') {
    return 'https://localhost:9001/v1/';
  }

  return `https://app${getEnv()}constantcontact.com/v1/`;
};

const getUrl = (path: string) => `${getBaseUrl()}stripe${path[0] !== '/' ? '/' : ''}${path}`;

export type StripeCustomer = {
  customer: {
    currency: string;
  };
  paymentMethod?: {
    id: string;
  };
};

export async function getStripeCustomer(): Promise<StripeCustomer> {
  return (await axios.get(getUrl('/customer'))).data;
}

export async function getStripeCustomerPortalDetails({ flowType, returnUrl }: { flowType: string; returnUrl: string }) {
  return (
    await axios.post(getUrl('/portal'), {
      flowType,
      returnUrl: returnUrl || undefined,
      afterCompletion: returnUrl ? { type: 'redirect', returnUrl } : undefined,
    })
  ).data;
}
